function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M70.0002 52.6564V49.5613C70.0002 47.9195 69.3481 46.345 68.1872 45.1842C67.0263 44.0233 65.4518 43.3711 63.8101 43.3711H51.4297C49.7879 43.3711 48.2134 44.0233 47.0526 45.1842C45.8917 46.345 45.2395 47.9195 45.2395 49.5613V52.6564",
  stroke: "#930100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.6196 37.1812C61.0384 37.1812 63.8098 34.4097 63.8098 30.991C63.8098 27.5722 61.0384 24.8008 57.6196 24.8008C54.2009 24.8008 51.4294 27.5722 51.4294 30.991C51.4294 34.4097 54.2009 37.1812 57.6196 37.1812Z",
  stroke: "#930100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.6666 48.75V44.5833C34.6666 42.3732 33.7886 40.2536 32.2258 38.6908C30.663 37.128 28.5434 36.25 26.3333 36.25H9.66659C7.45645 36.25 5.33683 37.128 3.77403 38.6908C2.21123 40.2536 1.33325 42.3732 1.33325 44.5833V48.75",
  stroke: "#930100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9996 27.9167C22.602 27.9167 26.3329 24.1857 26.3329 19.5833C26.3329 14.981 22.602 11.25 17.9996 11.25C13.3972 11.25 9.66626 14.981 9.66626 19.5833C9.66626 24.1857 13.3972 27.9167 17.9996 27.9167Z",
  stroke: "#930100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M50.8888 21.1223V18.8862C50.8888 17.7001 50.4176 16.5626 49.5789 15.7239C48.7402 14.8852 47.6027 14.4141 46.4166 14.4141H37.4724C36.2863 14.4141 35.1488 14.8852 34.3101 15.7239C33.4714 16.5626 33.0002 17.7001 33.0002 18.8862V21.1223",
  stroke: "#930100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9453 9.94426C44.4152 9.94426 46.4174 7.94202 46.4174 5.47213C46.4174 3.00224 44.4152 1 41.9453 1C39.4754 1 37.4731 3.00224 37.4731 5.47213C37.4731 7.94202 39.4754 9.94426 41.9453 9.94426Z",
  stroke: "#930100",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgStaffGroupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 49,
    viewBox: "0 0 71 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffGroupIcon);
export default __webpack_public_path__ + "static/media/staff-group-icon.d2cd54d9.svg";
export { ForwardRef as ReactComponent };